import React, { ReactText, useState } from 'react'
import clsx from 'clsx'

/* blocks */
import Accordion from '@/atoms/Accordion/Accordion'

/* utils */
import { dataLayerFaqClickEvent } from '@/utils/functions/dataLayerEvents'

/* assets */
import { ReactComponent as PlusIcon } from 'public/assets/icons/plus.svg'
import { ReactComponent as CommentIcon } from 'public/assets/icons/comment.svg'

/* styling */
import styles from './_.module.css'

interface Props {
  faqs: { id: string | number; question: string; answer: string }[]
}

const Faq: React.FC<Props> = ({ faqs }) => {
  const [activeKey, setActiveKey] = useState<ReactText>()

  const faqList1 = [...faqs].splice(0, Math.ceil(faqs.length / 2))
  const faqList2 = [...faqs].splice(Math.ceil(faqs.length / 2))

  const _renderFaqList = (
    list: { id: string | number; question: string; answer: string }[]
  ) =>
    list.map(faq => (
      <Accordion
        key={faq.id}
        elementKey={faq.question}
        activeKey={activeKey}
        className={clsx(styles.accordion)}
        title={faq.question}
        handleChange={(key, isOpen) => {
          setActiveKey(key)
          if (isOpen) {
            dataLayerFaqClickEvent({ faqQuestion: key?.toString() ?? '' })
          }
        }}
        Icon={PlusIcon}
      >
        <p className="text-paragraph-3 text-gray-70">{faq.answer}</p>
      </Accordion>
    ))

  return (
    <section className="bg-yellow-10">
      <div className="max-desktop-width  |  mx-auto py-16 px-5 sm:px-10 lg:px-6">
        <h2 className="h5 font-medium text-center  |  mb-7">
          <CommentIcon className="inline-block  |  mb-2 mr-5 sm:mb-0" />
          <span className="block sm:inline-block align-middle">
            Frequently Asked Questions
          </span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
          <div>{_renderFaqList(faqList1)}</div>
          <div>{_renderFaqList(faqList2)}</div>
        </div>
      </div>
    </section>
  )
}

export default Faq
